import { useEffect } from 'react';
import { createLinkTag } from '../helpers';

const useResourceHints = (options: {
  rel?: string;
  href: string | undefined;
  crossorigin?: string;
}) => {
  const { rel = 'preconnect', href, crossorigin = '' } = options;

  useEffect(() => {
    if (!href) {
      return;
    }

    const tag = createLinkTag(rel, href, crossorigin);
    document.head.appendChild(tag);

    return () => {
      document.head.removeChild(tag);
    };
  }, [rel, href, crossorigin]);
};

export default useResourceHints;
